<div class="sendCase">
  <div class="dg-txt-primary caseId" mat-dialog-title>
    {{ "send_case.send_case" | translate }} : {{ caseData?.docNo }}
  </div>
  <mat-dialog-content class="dialogContentPadding">
    <div class="container-fluid p-0">
      <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedUnit">
        <div class="row m-0 pb-3">
          <div class="col-12 p-0 pb-1 processInfo">
            <div class="row m-0 mb-2">
              <div class="processClass col-2 p-0">
                {{ "send_case:process" | translate }}
              </div>
              <div class="col-1 p-0">:</div>
              <div class="col-8 p-0">{{ caseData?.subject }}</div>
            </div>
          </div>
          <div class="col-12 p-0 pb-1 processInfo">
            <div class="row m-0">
              <div class="processDescriptionClass col-2 p-0">
                {{ "send_case:processDescription" | translate }}
              </div>
              <div class="col-1 p-0">:</div>
              <div class="col-6 p-0">
                {{ caseData?.description }}
              </div>
            </div>
          </div>
        </div>
        <div class="row m-0">
          <div class="p-0 col-8">
            <mat-card>
              <mat-card-header class="dg-txt-primary titleText">{{
                "send_case.my_hierarchy" | translate
              }}</mat-card-header>
              <mat-card-content class="mt-3 overflow-auto card-content">
                <div
                  *ngFor="let level of forwardLevel"
                  class="borderWorkflowAction"
                  [ngClass]="{ 'd-none': noPesronInForward }"
                >
                  <div
                    class="row m-0"
                    [ngClass]="
                      level?.recipient?.length == 1
                        ? 'justify-content-center'
                        : 'justify-content-start'
                    "
                  >
                    <div
                      class="col-6 p-0"
                      *ngFor="let unit of level?.recipient; let i = index"
                      [ngClass]="{
                        borderAround:
                          level?.recipient?.length > 2 && i % 2 === 0,
                        borderBottom:
                          level?.recipient?.length > 2 &&
                          i + 2 <= level?.recipient?.length - 1
                      }"
                    >
                      <div class="row m-0 p-3">
                        <div class="col-1 p-0 d-flex align-item-center">
                          <mat-radio-button
                            [value]="unit"
                            (change)="handleChange($event, 'f')"
                          ></mat-radio-button>
                        </div>
                        <div class="col-3 ps-2">
                          <dg-file-upload
                            [title]="profileAttachTitle"
                            [profileAttachment]="isProfileComponent"
                            [acceptedType]=""
                            [maxSize]=""
                            [uniqueAttachmentId]=""
                            [allowFileToAttach]="false"
                            [attachId]="data.attachId ? data.attachId : ''"
                            [defaultImagePath]="'./assets/images/userPic.png'"
                          >
                          </dg-file-upload>
                        </div>
                        <div class="col-8 p-0">
                          <div class="row m-0">
                            <div class="col-12 p-0 selfText dg-fs-16">
                              {{ unit?.empName }}
                            </div>
                            <div class="col-12 p-0 selfOrg dg-fs-14">
                              {{ unit?.unitName }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="verticalLine" *ngIf="!noPesronInForward">
                  <div class="line"></div>
                </div>
                <div class="selfLevel p-2 borderSelf">
                  <div class="row m-0 justify-content-center">
                    <div class="col-5 p-0">
                      <div class="p-3 d-flex">
                        <div class="col-4 p-0">
                          <dg-file-upload
                            [title]="profileAttachTitle"
                            [profileAttachment]="isProfileComponent"
                            [acceptedType]=""
                            [maxSize]=""
                            [uniqueAttachmentId]=""
                            [allowFileToAttach]="false"
                            [attachId]="data.attachId ? data.attachId : ''"
                            [defaultImagePath]="'./assets/images/userPic.png'"
                          >
                          </dg-file-upload>
                        </div>
                        <div class="col-8 p-0">
                          <div class="row m-0">
                            <div
                              class="col-12 p-0 dg-txt-primary selfText dg-fs-16"
                            >
                              {{ currentLevelEmpName }}
                            </div>
                            <div
                              class="col-12 p-0 selfOrg dg-fs-14"
                              [matTooltip]="currentLevelEmpDsgn"
                            >
                              {{ currentLevelEmpDsgn }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="verticalLine" *ngIf="!noPesronInRetun">
                  <div class="line"></div>
                </div>
                <div
                  *ngFor="let level of returnLevel"
                  class="p-2 borderWorkflowAction"
                  [ngClass]="{ 'd-none': noPesronInRetun }"
                >
                  <div
                    class="row m-0"
                    [ngClass]="
                      level?.recipient?.length == 1
                        ? 'justify-content-center'
                        : 'justify-content-start'
                    "
                  >
                    <div
                      class="col-6 p-0"
                      *ngFor="let unit of level?.recipient; let i = index"
                      [ngClass]="{
                        borderAround:
                          level?.recipient?.length > 2 && i % 2 === 0,
                        borderBottom:
                          level?.recipient?.length > 2 &&
                          i + 2 <= level?.recipient?.length - 1
                      }"
                    >
                      <div class="row m-0 p-3">
                        <div class="col-1 p-0 d-flex align-item-center">
                          <mat-radio-button
                            [value]="unit"
                            (change)="handleChange($event, 'r')"
                          ></mat-radio-button>
                        </div>
                        <div class="col-3 ps-2">
                          <dg-file-upload
                            [title]="profileAttachTitle"
                            [profileAttachment]="isProfileComponent"
                            [acceptedType]=""
                            [maxSize]=""
                            [uniqueAttachmentId]=""
                            [allowFileToAttach]="false"
                            [attachId]="data.attachId ? data.attachId : ''"
                            [defaultImagePath]="'./assets/images/userPic.png'"
                          >
                          </dg-file-upload>
                        </div>
                        <div class="col-8 p-0">
                          <div class="row m-0">
                            <div class="col-12 p-0 selfText dg-fs-16">
                              {{ unit?.empName }}
                            </div>
                            <div class="col-12 p-0 selfOrg dg-fs-14">
                              {{ unit?.unitName }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="col-4 pe-0">
            <div class="row m-0">
              <div
                class="col-12 p-0 pb-2"
                *ngIf="senderLevel[0]?.recipient?.length > 0"
              >
                <mat-card>
                  <mat-card-header class="dg-txt-primary titleText">{{
                    "send_case.sender" | translate
                  }}</mat-card-header>
                  <mat-card-content class="mt-3">
                    <div
                      *ngFor="let unit of senderLevel[0]?.recipient"
                      class="p-2"
                    >
                      <div class="row m-0 justify-content-start">
                        <div class="col-1 p-0 d-flex align-item-center">
                          <mat-radio-button
                            [value]="unit"
                            (change)="handleChange($event, 'u')"
                          ></mat-radio-button>
                        </div>
                        <div class="col-3">
                          <dg-file-upload
                            [title]="profileAttachTitle"
                            [profileAttachment]="isProfileComponent"
                            [acceptedType]=""
                            [maxSize]=""
                            [uniqueAttachmentId]=""
                            [allowFileToAttach]="false"
                            [attachId]="unit.attachId ? unit.attachId : ''"
                            [defaultImagePath]="'./assets/images/userPic.png'"
                          >
                          </dg-file-upload>
                        </div>
                        <div class="col-8 p-0">
                          <div class="row m-0">
                            <div class="col-12 p-0 selfText dg-fs-16">
                              {{ unit?.empName }}
                            </div>
                            <div class="col-12 p-0 selfOrg dg-fs-14">
                              {{ unit?.unitName }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
              <div class="col-12 p-0" *ngIf="initiator?.postId">
                <mat-card>
                  <mat-card-header class="dg-txt-primary titleText">{{
                    "send_case.initiator" | translate
                  }}</mat-card-header>
                  <mat-card-content class="mt-3">
                    <div class="p-2">
                      <div class="row m-0 justify-content-start">
                        <div class="col-12 px-0">
                          <div class="row m-0">
                            <div
                              class="col-1 p-0 d-flex align-item-center"
                            ></div>
                            <div class="col-3">
                              <dg-file-upload
                                [title]="profileAttachTitle"
                                [profileAttachment]="isProfileComponent"
                                [acceptedType]=""
                                [maxSize]=""
                                [uniqueAttachmentId]=""
                                [allowFileToAttach]="false"
                                [attachId]="data.attachId ? data.attachId : ''"
                                [defaultImagePath]="
                                  './assets/images/userPic.png'
                                "
                              >
                              </dg-file-upload>
                            </div>
                            <div class="col-8 p-0">
                              <div class="row m-0">
                                <div class="col-12 p-0 selfText dg-fs-16">
                                  {{ initiator?.initiatorName }}
                                </div>
                                <div class="col-12 p-0 selfOrg dg-fs-14">
                                  {{ initiator?.dsgnName }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </div>
      </mat-radio-group>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dg-btn" align="end">
    <button mat-raised-button mat-dialog-close>Cancel</button>
    <button
      color="primary"
      mat-raised-button
      (click)="onSendCase()"
      [disabled]="isButtonDisable()"
    >
      Send
    </button>
  </mat-dialog-actions>
</div>
